import { Component, input, signal, ViewEncapsulation } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ColorConstants } from '@celum/common-components/constants';
import { CelumIcon, IconConfiguration } from '@celum/common-components/icon';
import { SimpleContextMenuItem } from '@celum/internal-components/systembar';
import { SpaceAwareTooltipDirective } from '@celum/ng2base/directives';
import { StripUrlProtocolPipe } from '@celum/ng2base/pipes';

/**
 * Deprecated, should be removed with https://celum.atlassian.net/browse/CH-9973
 */
@Component({
  selector: 'celum-systembar-formats',
  templateUrl: './systembar-formats.component.html',
  styleUrl: './systembar-formats.component.scss',
  imports: [MatMenuModule, MatTooltipModule, CelumIcon, SpaceAwareTooltipDirective, StripUrlProtocolPipe],
  // Needed to style the context menu items
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'celum-systembar-formats',
    '[class.celum-systembar_components--active]': 'isMenuOpen()'
  }
})
export class SystembarFormatsComponent {
  public contextMenuItems = input<SimpleContextMenuItem[]>();

  protected isMenuOpen = signal(false);

  protected iconConfiguration = new IconConfiguration('settings-outlined').withIconSize(34).withColor(ColorConstants.TERTIARY);

  protected onIconClick(event: MouseEvent): void {
    if (this.contextMenuItems().length === 1) {
      this.contextMenuItems()[0].onClick();
      event.stopPropagation();
    }
  }
}
